import './create-logistics-vehicle-form/create-logistics-vehicle-form.component';
import './create-logistics-vehicle-form/create-logistics-vehicle-form.scss';

import './logistics-vehicle-detailed-view/logistics-vehicle-detailed-view.component'
import './logistics-vehicle-detailed-view/logistics-vehicle-detailed-view.scss'

import './logistics-vehicle-documents-and-reminders/logistics-vehicle-documents-and-reminders.component'
import './logistics-vehicle-documents-and-reminders/logistics-vehicle-documents-and-reminders.scss'

import './logistics-vehicle-info/logistics-vehicle-info.component'
import './logistics-vehicle-info/logistics-vehicle-info.scss'

import './logistics-vehicle-link/logistics-vehicle-link.component'

import './logistics-vehicle-multi-select/logistics-vehicle-multi-select.component'
import './logistics-vehicle-multi-select/logistics-vehicle-multi-select.scss'

import './logistics-vehicle-multi-select-list/logistics-vehicle-multi-select-list.component'
import './logistics-vehicle-multi-select-list/logistics-vehicle-multi-select-list.scss'

import './logistics-vehicle-profile/logistics-vehicle-profile.component'
import './logistics-vehicle-profile/logistics-vehicle-profile.scss'

import './logistics-vehicle-select/logistics-vehicle-select.component';
import './logistics-vehicle-select/logistics-vehicle-select.scss';

import './logistics-vehicle-select-list/logistics-vehicle-select-list.component';
import './logistics-vehicle-select-list/logistics-vehicle-select-list.scss';

import './logistics-vehicle-status-select-list/logistics-vehicle-status-select-list.component';
import './logistics-vehicle-status-select-list/logistics-vehicle-status-select-list.scss';

import './logistics-vehicle-status-select/logistics-vehicle-status-select.component';
import './logistics-vehicle-status-select/logistics-vehicle-status-select.scss';

import './logistics-vehicles-import-view/logistics-vehicles-import-view.component';
import './logistics-vehicles-import-view/logistics-vehicles-import-view.scss';

import './logistics-vehicles-list-view/logistics-vehicles-list-view.component';
import './logistics-vehicles-list-view/logistics-vehicles-list-view.scss';

import './logistics-vehicles-table/logistics-vehicles-table.component';
import './logistics-vehicles-table/logistics-vehicles-table.scss';

import './logistics-vehicles-table-row/logistics-vehicles-table-row.component';
import './logistics-vehicles-table-row/logistics-vehicles-table-row.scss';

import './logistics-vehicles-display-list/logistics-vehicles-display-list.component';
import './logistics-vehicles-display-list/logistics-vehicles-display-list.scss';

import './logistics-vehicle-select-item/logistics-vehicle-select-item.component';
import './logistics-vehicle-select-item/logistics-vehicle-select-item.scss';
